// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';

// import form components
import {EmailInput, PasswordInput, SelectInput, TextInput} from '../../../global/components/forms'
import PQLogo from "../../../global/components/logo/PQLogo";
import SwitchComponent from "../../../global/components/base/SwitchComponent";
import {redirectToPage} from "../../../global/utils/routerUtils";
import CheckedComponent from "../../../global/components/base/CheckedComponent";

const UserRegisterForm = ({
  handleChange,
  handleSubmit,
  user,
  redirectPath,
  errors,
  organisations,
  items,
  disabled = true,
  isStudent = false,
}) => {
  const location = useLocation();

  return (
    <div className="full-white-page content-in-center pt-8">
        <div className="register-form-block">
            <div className="logo-slot">
                <PQLogo className="h-[80px]"/>
            </div>
            {!isStudent ?
                <div className="title-and-switch">
                    <h1 className="pb-4 text-gray-900"> Register </h1>
                    <SwitchComponent
                        leftTitle="Register"
                        rightTitle="Sign In"
                        leftIsActive={'/user/register' === location.pathname}
                        rightIsActive={false}
                        leftAction={() => {
                            redirectToPage('/user/register')
                        }}
                        rightAction={() => {
                            redirectToPage('/user/login')
                        }}/>
                </div> :
                <div className="title-and-switch">
                    <h1 className="text-gray-900 text-center"> You’ve been invited to join Practice Quest </h1>
                    <p className="text-gray-700 text-center">To activate your account, set a secure password below. Once you’re done, you’ll be taken to your dashboard.</p>
                </div>
            }
            <form name="userForm" onSubmit={handleSubmit} className="userForm">
                <div className="w-full">
                    <p className="pb-2 text-gray-700">Organisation <span className="text-blue-600">*</span></p>
                    <SelectInput
                        multiple={false}
                        change={handleChange}
                        items={organisations}
                        displayKey={'name'}
                        valueKey={'_id'}
                        selectedValue={user.organisation}
                        name="organisation"
                        error={errors.organisation_error}
                    />
                </div>
                <div className="w-full">
                    <p className="pb-2 text-gray-700">First name <span className="text-blue-600">*</span></p>
                    <TextInput
                        border="border rounded-md border-stone-200 focus:border-2 focus:border-blue-600 focus:outline-none active:outline-none active:border-2 active:border-blue-600 max-h-[40px]"
                        change={handleChange}
                        name="first_name"
                        value={user.first_name}
                        error={errors.first_name_error}
                    />
                </div>
                <div className="w-full">
                    <p className="pb-2 text-gray-700">Last name <span className="text-blue-600">*</span></p>
                    <TextInput
                        border="border rounded-md border-stone-200 focus:border-2 focus:border-blue-600 focus:outline-none active:outline-none active:border-2 active:border-blue-600 max-h-[40px]"
                        change={handleChange}
                        name="last_name"
                        value={user.last_name}
                        error={errors.last_name_error}
                    />
                </div>
                <div className="w-full">
                    <p className="pb-2 text-gray-700">Email Address <span className="text-blue-600">*</span></p>
                    <EmailInput
                        handleError={errors.email_error}
                        name="username"
                        value={user.username}
                        change={handleChange}
                        required={true}
                        onTheFlyCheck={false}
                        disabled={isStudent}
                    />
                </div>
                <div className="w-full">
                    <p className="pb-2 text-gray-700">Password <span className="text-blue-600">*</span></p>
                    <PasswordInput
                        errorHandle={errors.password_error}
                        name="password"
                        value={user.password}
                        change={handleChange}
                        required={true}
                    />
                </div>

                <CheckedComponent items={items}/>

                <div className="pt-2">
                    <button
                        disabled={disabled}
                        className="btn-blue w-full"
                        type="submit">{isStudent ? 'Join' : 'Register'}</button>
                </div>
            </form>
            <div className="flex w-full align-middle justify-center">
                <p className="py-2 text-sm">Already have an account? </p>
                {redirectPath ?
                    <Link
                        to={`/user/login/${redirectPath}`}
                        className="mx-2 text-blue-700 text-sm my-auto"
                    >
                        Sign in
                    </Link>
                    :
                    <Link
                        to={{
                            pathname: "/user/login"
                            , state: location.state
                        }}
                        className="mx-2 text-blue-700 text-sm my-auto"
                    >
                        Sign in
                    </Link>
                }

            </div>
        </div>
    </div>
  )
}

UserRegisterForm.propTypes = {
  handleChange: PropTypes.func.isRequired
  , handleSubmit: PropTypes.func.isRequired
  , user: PropTypes.object.isRequired
  , errors: PropTypes.object.isRequired
}

export default UserRegisterForm;
